// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__kasmz","blocksContainer":"footer_blocksContainer__-6Dri"};